{
  "common.close": "Stäng",
  "common.athleteFallback": "idrottare {id}",
  "splash.title": "{app} — animerad visualisering av aktiviteter",
  "splash.tagline": "Dina Strava-data i&nbsp;rörelse",
  "splash.demo": "Demo",
  "tab.query.title": "{name}s karta",
  "tab.query.heading": "Hämta aktiviteter:",
  "tab.query.optDays": "senaste dagarna",
  "tab.query.optActivities": "senaste aktiviteterna",
  "tab.query.optIds": "Aktivitets-ID",
  "tab.query.optDates": "Datumintervall",
  "tab.query.idsPlaceholder": "ange aktivitets-ID här",
  "tab.query.after": "Efter:",
  "tab.query.before": "Före:",
  "tab.query.autozoom": "Zooma automatiskt <i class=\"hf hf-bullseye\"></i> till urvalet efter import",
  "tab.query.queryButton": "<i class=\"hf hf-cloud-download\"></i> Hämta",
  "tab.query.createAccount": "Skapa ett konto och/eller logga in.",
  "tab.query.sports": "Sporter:",
  "tab.query.allSports": "Alla sporter",
  "tab.query.sportsExcept": "Alla utom",
  "tab.query.sportsNone": "Inga",
  "tab.query.loadingSports": "Läser in sporter…",
  "tab.query.sportsFailed": "Det gick inte att läsa in sporterna på den här kartan",
  "tab.query.noSports": "Inga aktiviteter än",
  "tab.activities.title": "Visade aktiviteter",
  "tab.activities.clearSelection": "Rensa urval",
  "tab.activities.renderSelected": "Visa valda",
  "tab.activities.zoomToSelection": "<i class=\"fas fa-search-plus\"></i> <i class=\"far fa-object-group\"></i> <i class=\"fas fa-search-minus\"></i> Zooma till urvalet",
  "tab.controls.title": "Lagerinställningar",
  "tab.controls.timescale": "Tidsskala <i>&tau;</i>",
  "tab.controls.timescaleHint": "uppspelningshastighet",
  "tab.controls.period": "Period <i>T</i>",
  "tab.controls.periodHint": "aktivitet ~ modell",
  "tab.controls.dotSize": "Punktstorlek",
  "tab.controls.pathWidth": "Linjebredd",
  "tab.controls.pathWidthHint": "noll döljer linjerna",
  "tab.controls.colors": "Färger",
  "tab.controls.colorsHint": "rotera färgpaletten",
  "tab.controls.shadows": "Skuggor",
  "tab.profile.loginTitle": "Logga in",
  "tab.profile.anonNote": "Logga in med Strava för att se dina egna aktiviteter och hantera ditt Heatflask-konto.",
  "tab.profile.loginLink": "Logga in med Strava",
  "tab.profile.editOnStrava": "Redigera din profil på Strava",
  "tab.profile.indexNote": "Vi indexerar sammanfattningar av dina aktiviteter för snabb åtkomst.",
  "tab.profile.viewIndex": "Visa index",
  "tab.profile.sharedMaps": "Delade kartor",
  "tab.profile.sharedMapsNote": "Av: bara du kan se dina aktiviteter på Heatflask. På: alla som har en länk till din karta kan se de aktiviteter du har gjort offentliga på Strava. Dina privata aktiviteter förblir dina i båda fallen. <a id=\"profile-privacy-link\" href=\"#\" target=\"_blank\" rel=\"noopener\">Så fungerar integriteten</a>",
  "tab.profile.logout": "Logga ut",
  "tab.profile.deleteAccount": "Radera konto",
  "tab.profile.deleteConfirm": "Vill du radera ditt Heatflask-konto?\n\nDå tas dina indexerade aktiviteter bort och Heatflasks åtkomst till dina Strava-data återkallas. Det går inte att ångra.",
  "tab.profile.languageHeading": "Språk",
  "tab.profile.languageAuto": "Automatiskt",
  "tab.profile.translateNote": "<a id=\"translate-link\" target=\"_blank\" rel=\"noopener\">Hjälp oss att rätta eller lägga till översättningar!</a>",
  "tab.profile.unitsHeading": "Enheter",
  "tab.profile.unitsAuto": "Automatiskt",
  "tab.profile.unitsMetric": "Metriska (km, m)",
  "tab.profile.unitsImperial": "Brittiska (mi, ft)",
  "tab.profile.textSizeHeading": "Textstorlek",
  "tab.profile.textSmaller": "Mindre",
  "tab.profile.textReset": "Normal",
  "tab.profile.textLarger": "Större",
  "tab.profile.mapDefaultsHeading": "Standardinställningar för kartan",
  "tab.profile.mapDefaultsNote": "Börja med den här bakgrundskartan, terrängen och lagerinställningarna när du öppnar en karta vars länk inte anger egna. Länkar du delar visar fortfarande exakt det du ser.",
  "tab.profile.mapDefaultsSave": "Spara som mina standardinställningar",
  "tab.profile.mapDefaultsForget": "Glöm",
  "tab.info.title": "Info",
  "tab.info.controlsHeading": "Styrning",
  "tab.info.shiftDragKey": "<kbd>Shift</kbd> + dra",
  "tab.info.shiftDragDesc": "Markera aktiviteter inom en ruta. På pekskärm trycker du först på <i class=\"hf-object-group\"></i> och drar sedan med ett finger. Den senast markerade aktiviteten visar sina detaljer, och aktivitetslistan rullar fram till den.",
  "tab.info.ctrlDragKey": "<kbd>Ctrl</kbd> + dra",
  "tab.info.ctrlDragDesc": "Rotera och luta kartan i 3D, eller använd två fingrar",
  "tab.info.spaceKey": "<kbd>Space</kbd>",
  "tab.info.spaceDesc": "Öppna eller stäng sidopanelen",
  "tab.info.arrowsKey": "<kbd>&uarr;</kbd> <kbd>&darr;</kbd>",
  "tab.info.arrowsDesc": "Föregående eller nästa flik",
  "tab.info.escKey": "<kbd>Esc</kbd>",
  "tab.info.escDesc": "Stäng sidopanelen",
  "tab.info.liveUrlHeading": "Levande URL",
  "tab.info.liveUrlDesc": "Kartvyn och animationsinställningarna sparas i sidans URL, så alla du delar den med ser samma vy.",
  "tab.info.videoHeading": "Videoexport",
  "tab.info.videoDesc": "Knappen <i class=\"hf-video-camera\"></i> spelar in animationen som MP4: tryck på den, anpassa rutan över den del av kartan du vill ha med och tryck igen för att spela in. Ett helt varv av animationen spelas in, så att videon loopar sömlöst; ett varv som är längre än {max} sekunder (den längsta video Strava tar emot) klipps vid {max}.",
  "tab.info.contributeHeading": "Bidra",
  "tab.info.sponsor": "<i class=\"hf-github\"></i> Sponsra på GitHub",
  "tab.info.contactsHeading": "Kontakt",
  "map.basemapAndTerrain": "Bakgrundskarta och terräng",
  "map.pauseAnimation": "Pausa animationen",
  "map.resumeAnimation": "Återuppta animationen",
  "capture.record": "Spela in video ({period} s per varv)",
  "capture.recordTruncated": "Spela in video (ett varv tar {period} s; bara de första {max} s spelas in)",
  "capture.recordArea": "Spela in området inuti rutan",
  "capture.stop": "Stoppa inspelningen",
  "capture.selectionTooSmall": "markeringen är för liten",
  "capture.saved": "sparade {name} ({size})",
  "capture.cancelled": "inspelningen avbröts",
  "capture.failed": "inspelningen misslyckades: {error}",
  "capture.loadingEncoder": "läser in kodaren…",
  "capture.waitingForMap": "väntar på att kartan ska läsas in…",
  "capture.encoding": "kodar… {percent} %",
  "capture.finalizing": "slutför…",
  "share.title": "Dela en länk till den här kartan",
  "share.copied": "länken har kopierats",
  "share.copiedUnshared": "länken har kopierats – men din karta är inte delad, så ingen annan kan öppna den. Slå på ”Delade kartor” för att ändra det.",
  "share.unshared": "Din karta är inte delad, så ingen annan kan öppna den här länken. Slå på ”Delade kartor” för att ändra det.",
  "share.copyThis": "Kopiera den här länken:",
  "update.available": "En ny version av Heatflask finns tillgänglig.",
  "update.reload": "Läs in igen",
  "import.title": "Importerar",
  "import.stop": "Stoppa",
  "import.stopping": "stoppar…",
  "import.contacting": "ansluter till Strava…",
  "import.countOf": "Aktiviteter: {received} av {total}",
  "import.count": "Aktiviteter: {received}",
  "import.waitStrava": "Pausad av Stravas nedladdningsgräns till {time}. Låt sidan vara öppen; att läsa in igen gör det inte snabbare.",
  "import.waitRationed": "Dagens snabba nedladdningar är förbrukade. Resten fortsätter kl. {time}, långsammare. Låt sidan vara öppen.",
  "import.dailyLimit": "Stravas dagliga nedladdningsgräns är förbrukad. Försök igen efter {time}.",
  "import.dailyRationed": "Du har använt din andel av Strava-nedladdningar för i dag. Försök igen efter {time}.",
  "import.noActivitiesYet": "Ditt Strava-konto har inga aktiviteter än. Registrera eller ladda upp en på Strava så dyker den upp här.",
  "table.noActivities": "inga aktiviteter",
  "table.untitled": "(namnlös)",
  "activities.pageTitle": "{app} — Aktivitetsindex",
  "activities.heading": "Aktivitetsindex",
  "activities.fetching": "Hämtar aktiviteter...",
  "activities.rateLimit": "Stravas anropsgräns är nådd; fortsätter kl. {time}",
  "activities.noData": "Tyvärr, inga data &#128577;",
  "activities.colServerCache": "Spåret är cachat på servern (Mongo)",
  "activities.colBrowserCache": "Spåret är cachat i den här webbläsaren",
  "activities.cachedServer": "Spåret för {id} är cachat på servern",
  "activities.notCachedServer": "Spåret för {id} är inte cachat på servern",
  "activities.cachedBrowser": "Spåret för {id} är cachat i den här webbläsaren",
  "activities.notCachedBrowser": "Spåret för {id} är inte cachat i den här webbläsaren",
  "sport.AlpineSki": "Utförsåkning",
  "sport.BackcountrySki": "Topptur",
  "sport.Badminton": "Badminton",
  "sport.Basketball": "Basket",
  "sport.Canoeing": "Kanot",
  "sport.Cricket": "Cricket",
  "sport.Crossfit": "Crossfit",
  "sport.Dance": "Dans",
  "sport.EBikeRide": "Elcykeltur",
  "sport.Elliptical": "Crosstrainer",
  "sport.EMountainBikeRide": "Elmountainbike",
  "sport.Golf": "Golf",
  "sport.GravelRide": "Gruscykling",
  "sport.Handcycle": "Handcykel",
  "sport.HighIntensityIntervalTraining": "HIIT",
  "sport.Hike": "Vandring",
  "sport.IceSkate": "Skridskor",
  "sport.InlineSkate": "Inlines",
  "sport.Kayaking": "Kajak",
  "sport.Kitesurf": "Kitesurfing",
  "sport.MountainBikeRide": "Mountainbike",
  "sport.NordicSki": "Längdskidor",
  "sport.Padel": "Padel",
  "sport.PhysicalTherapy": "Fysioterapi",
  "sport.Pickleball": "Pickleball",
  "sport.Pilates": "Pilates",
  "sport.Racquetball": "Racquetball",
  "sport.Ride": "Cykling",
  "sport.RockClimbing": "Klättring",
  "sport.RollerSki": "Rullskidor",
  "sport.Rowing": "Rodd",
  "sport.Run": "Löpning",
  "sport.Sail": "Segling",
  "sport.Skateboard": "Skateboard",
  "sport.Snowboard": "Snowboard",
  "sport.Snowshoe": "Snöskor",
  "sport.Soccer": "Fotboll",
  "sport.Squash": "Squash",
  "sport.StairStepper": "Trappmaskin",
  "sport.StandUpPaddling": "Paddelbräda",
  "sport.Surfing": "Surfing",
  "sport.Swim": "Simning",
  "sport.TableTennis": "Bordtennis",
  "sport.Tennis": "Tennis",
  "sport.TrailRun": "Terränglöpning",
  "sport.Velomobile": "Velomobil",
  "sport.VirtualRide": "Virtuell cykling",
  "sport.VirtualRow": "Virtuell rodd",
  "sport.VirtualRun": "Virtuell löpning",
  "sport.Volleyball": "Volleyboll",
  "sport.Walk": "Promenad",
  "sport.WeightTraining": "Styrketräning",
  "sport.Wheelchair": "Rullstol",
  "sport.Windsurf": "Vindsurfing",
  "sport.Workout": "Träningspass",
  "sport.Yoga": "Yoga"
}
